(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sketcher", [], factory);
	else if(typeof exports === 'object')
		exports["sketcher"] = factory();
	else
		root["sketcher"] = factory();
})(window, function() {
return 